import { getDepartmentListRequest } from "../../data/departmentApi";

function getPayloadData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getDepartmentListUseCase() {
  return getPayloadData(await getDepartmentListRequest());
}
